import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { CategoryService } from '../../services/category.service';
import { EnfoqueService } from '../../services/enfoque.service';
import { EjecutorService } from '../../services/ejecutor.service';
import { ZoneService } from '../../services/zone.service';
import { ToastrService } from 'ngx-toastr';
import { EventEmitterService } from '../../services/event-emitter.service';
import { EventBiService } from 'src/app/services/event-bi.service';
import { EventCapacitacionService } from 'src/app/services/event-capacitacion.service';
import { EventNavbarService } from 'src/app/services/event-navbar.service';
import { EventMantenedoresService } from 'src/app/services/event-mantenedores.service';
import { EventCargaMasivaService } from 'src/app/services/carga-masiva.service';
import { EventAprobacionMasivaService } from 'src/app/services/event-aprobacion-masiva.service';
import { UserService } from 'src/app/services/user.service';
import { CapacitacionModalComponent } from 'src/app/components/capacitacion-modal/capacitacion-modal.component';

import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  public isCollapsed = false;
  rolid: any;
  heightScreen: number;
  usuarioHabilitado: boolean = false;
  sidebarIsOpen = false;
  creationMode: string;
  categoriesWithFocos: any;
  enfoques: any;
  ejecutoresWithRelatores: any;
  zonas: any;
  loginData: any;
  nombreUsuario: string;
  rutContratista: string;
  valor: any;
  showPlan = true;
  loading = false;
  isIndicatorsCollapsed = false;
  isMobile: boolean = false;
  constructor(
    private modalService: NgbModal,
    private navigationService: NavigationService,
    private categoryService: CategoryService,
    private enfoqueService: EnfoqueService,
    private ejecutorService: EjecutorService,
    private zoneService: ZoneService,
    private toastr: ToastrService,
    private eventEmitterService: EventEmitterService,
    private eventBiService: EventBiService,
    private eventMantenedoresService: EventMantenedoresService,
    private eventCapacitacionService: EventCapacitacionService,
    private eventNavbarService: EventNavbarService,
    private eventCargaMasivaService: EventCargaMasivaService,
    private eventAprobacionMasivaService: EventAprobacionMasivaService,
    private router: Router,
    private loginService: LoginService) {
    this.isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

  }

  async ngOnInit() {

    await this.loginService.obtenerPermisosMenu('inicio').then((response) => {
      this.rolid = response.data.rolId
    })
    console.log("paso por aqui navbar",this.rolid)

  }


  getActualPage(): string {
    return this.navigationService.getActualPage();
  }
  // ngAfterViewChecked() {
  //   document.getElementById('sidebar').style.height = document.getElementById('contenedor').offsetHeight + 'px';
  // }
  toggleSidebar(openSidebar :Boolean ): void {
    if (this.isMobile) {
      document.getElementById('sidebar').style.width = this.sidebarIsOpen ? '0px' : '100%';
      document.getElementById('sidebar').style['z-index'] = this.sidebarIsOpen ? '0px' : '10';
      document.getElementById('close-arrow').style['z-index'] = this.sidebarIsOpen ? '0px' : '11';
    } else {
      if (openSidebar) {
        if (this.sidebarIsOpen) {
          Array.from(document.getElementsByClassName('navbar-toggle') as HTMLCollectionOf<HTMLElement>).forEach(element => {
            element.style['display'] = '';
          });
          Array.from(document.getElementsByClassName('menu-hidden') as HTMLCollectionOf<HTMLElement>).forEach(element => {
            element.style['display'] = 'none';
          });
          document.getElementById('sidebar').style.width = '50px';
        } else {
          Array.from(document.getElementsByClassName('navbar-toggle') as HTMLCollectionOf<HTMLElement>).forEach(element => {
            element.style['display'] = 'none';
          });
          Array.from(document.getElementsByClassName('menu-hidden') as HTMLCollectionOf<HTMLElement>).forEach(element => {
            element.style['display'] = '';
          });
          document.getElementById('sidebar').style.width = '250px';
          document.getElementById('sidebar').style['z-index'] = '10';
          document.getElementById('close-arrow').style['z-index'] = '11';
        }
        // document.querySelector<HTMLElement>('.sidebar div span').style.display = !this.sidebarIsOpen ? 'inline' : 'none';
        // document.getElementById('sidebar').style.width = this.sidebarIsOpen ? '0px' : '230px';
        // document.getElementById('sidebar').style.width = !this.sidebarIsOpen ? '0px' : '50px';
        // document.getElementById('sidebar').style.display = !this.sidebarIsOpen ? 'inline' : 'none';
        // document.getElementById('app-div').style['margin-left'] = this.sidebarIsOpen ? '0px' : '230px';
      }
    }
    this.sidebarIsOpen = !this.sidebarIsOpen;
  }

  onPageSelected(path: string): void {
    this.navigationService.goTo(path);
  }

  logout(): void {
    if (this.sidebarIsOpen) {
      this.toggleSidebar(false)
    }
    sessionStorage.removeItem('loginData')
    sessionStorage.clear();
    this.navigationService.goTo('/login');

    if (sessionStorage.getItem('logout') === null || sessionStorage.getItem('logout') === 'false') {
      sessionStorage.setItem('logout', 'true');
    }
  }

  getCategories(): any {
    return new Promise((resolve, reject) => {
      this.categoryService.listWithFocos()
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }

  getEnfoques(): any {
    return new Promise((resolve, reject) => {
      this.enfoqueService.list()
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }

  getEjecutores(): any {
    return new Promise((resolve, reject) => {
      this.ejecutorService.listWithRelatores()
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }

  getZonas(): any {
    return new Promise((resolve, reject) => {
      this.zoneService.getZonas()
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }

  estaHabilitado(user: string): any {
    this.categoryService.estaHabilitado(user).then(response => {
      this.usuarioHabilitado = response;
    })
      .catch(error => {
        this.usuarioHabilitado = false;
      });
    /*return new Promise(async (resolve, reject) => {
      await this.categoryService.estaHabilitado(user)
        .then(response => {
          this.usuarioHabilitado = response;
          resolve.bind(response);
        })
        .catch(error => {
          reject.bind(error);
          this.usuarioHabilitado = false;
        });
    });*/
  }

  openModal(modal: any, mode: string): void {
    $("#show-loading").css('display', 'grid')

    this.loading = true;
    const modalOptions: NgbModalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' };

    Promise.all([
      this.getCategories(),
      this.getEnfoques(),
      this.getEjecutores(),
      this.getZonas(),
    ])
      .then(results => {
        this.categoriesWithFocos = results[0];
        this.enfoques = results[1];
        this.ejecutoresWithRelatores = results[2];
        this.zonas = results[3];
        this.creationMode = mode;
        this.loading = false;
        this.modalService.open(modal, modalOptions);

        $("#show-loading").css('display', 'none')
      })
      .catch(error => console.error(error));

      // $("#show-loading").css('display', 'none')

  }

  openModalCargaPlan(modal: any): void {
    const modalOptions: NgbModalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' };
    this.modalService.open(modal, modalOptions);
  }

  onSave(): void {
    this.eventEmitterService.onFirstComponentButtonClick();
    this.eventEmitterService.onIndicatorsRefresh();
    this.eventEmitterService.onCalendarRefresh();
  }

  onSaveAccept(): void {
    this.eventEmitterService.onFirstComponentButtonClick();
    this.eventEmitterService.onIndicatorsRefresh();
    this.eventEmitterService.onCalendarRefresh();
  }

  openComponenteBi() {
    this.isIndicatorsCollapsed = true;
    if (this.sidebarIsOpen) {
      this.toggleSidebar(false)
    }
    this.eventBiService.onBiComponentButtonClick();
  }

  openMantenedores() {
    this.eventMantenedoresService.onMantenedoresComponentButtonClick();
    this.router.navigate(['/mantenedores']);
  }

  openComponentDashboard() {
    this.router.navigate(['/dashboard']);
  }

  openComponentDashboardContratista() {
    this.router.navigate(['/dashboard-contratista']);
  }

  openComponentCapacitaciones() {
    this.eventCapacitacionService.onCapacitacionesComponentButtonClick();
    this.router.navigate(['/capacitaciones']);
  }

  openComponentCargaMasiva() {
    // this.usuarioHabilitado = false;
    // const siempre_edita = this.loginData.usertableentity.roleId == 1 || this.loginData.usertableentity.roleId == 2 || this.loginData.usertableentity.roleId == 3 ? true : false;
    // this.estaHabilitado(this.loginData.usertableentity.roleId);
    /*if(!this.usuarioHabilitado && !siempre_edita){
      this.toastr.info('Lo sentimos, el periodo de creación de capacitaciones ha finalizado', 'Advertencia');

    }else{
      this.eventCargaMasivaService.onCargaMasivaComponentButtonClick();
      this.router.navigate(['/carga-masiva']);
    }*/
    // setTimeout(() => {
    //   console.log('Periodo de creacion finalizado desde navBar')
    //   if (this.usuarioHabilitado && siempre_edita) {
    //     this.eventCargaMasivaService.onCargaMasivaComponentButtonClick();
    //     this.router.navigate(['/carga-masiva']);
    //   } else {
    //     this.toastr.info('Lo sentimos, el periodo de creación de capacitaciones ha finalizado', 'Advertencia');
    //   }
    // }, 1000);
    this.eventCargaMasivaService.onCargaMasivaComponentButtonClick();
        this.router.navigate(['/carga-masiva']);

  }

  openAprobacion() {
    this.eventAprobacionMasivaService.onAprobacionMasivaComponentButtonClick();
    this.router.navigate(['/aprobacion']);
  }


  hidePlanificar() {
    const configuration = this.loginData.configurationTableEntity;
    const siempre_edita = this.loginData.usertableentity.planificaSiempre;
    const abreModal = configuration.map((x) => x.codigo == "FECHA_PLAN");
    if ((!abreModal || abreModal == "") && !siempre_edita) {
      this.showPlan = false;
    }
  }

  collapseIndicators(): void {
    this.isIndicatorsCollapsed = !this.isIndicatorsCollapsed;
    this.openComponentCapacitaciones();
  }

  clickSubMenu(){
    let header = document.getElementById("collapseExample");
    let btns = header.getElementsByClassName("submenu-item");
    for (let i = 0; i < btns.length; i++) {
      btns[i].addEventListener("click", function() {
      let current = document.getElementsByClassName("active");
      current[0].className = current[0].className.replace(" active", "");
      this.className += " active";
      });


}
  }
}
